module.exports = {"$xs":"0","$sm":"576px","$md":"768px","$lg":"992px","$very-lg":"1280px","$xl":"1440px","$xxl":"1650px"};